export const printStatuses=[ -1,920,922,999,100,-100 ]